import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';

export async function GET() {
  try {
    console.log('🏢 Fetching all gyms...');
    
    const { pool } = await import('@/lib/db');
    const [gymRows] = await pool.execute(
      'SELECT * FROM gyms ORDER BY created_at DESC'
    );
    
    const gyms = (gymRows as any[]).map(row => ({
      id: row.id,
      ownerEmail: row.owner_email,
      firstName: row.first_name,
      businessName: row.business_name,
      phone: row.phone,
      location: row.location,
      aboutGym: row.about_gym,
      photos: JSON.parse(row.photos || '[]'),
      services: JSON.parse(row.services || '[]'),
      membershipPricing: row.membership_pricing,
      membershipDescription: row.membership_description,
      operatingHours: JSON.parse(row.operating_hours || '{}'),
      facilityFeatures: JSON.parse(row.facility_features || '[]'),
      status: row.status,
      createdAt: row.created_at,
      updatedAt: row.updated_at,
    }));
    
    console.log(`✅ Found ${gyms.length} gyms`);
    
    return NextResponse.json({
      success: true,
      gyms
    });
  } catch (error) {
    console.error('❌ Error fetching gyms:', error);
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    return NextResponse.json(
      { error: 'Failed to fetch gyms: ' + errorMessage },
      { status: 500 }
    );
  }
}
